import { TextField } from '@material-ui/core';
import React from 'react';

import muiInputLabelModuleCss from '../../../assets/css/mui.text-field.input-label.module.css';
import muiInputModuleCss from '../../../assets/css/mui.input.module.css';
import muiTextFieldModuleCss from '../../../assets/css/mui.text-field.module.css';
import NumberFormat from 'react-number-format';
import AdornmentState from './AdornmentState';
import InputEvents from './InputEvents';
import GoogleTagManager from '../../../gtm/GoogleTagManager';
import GtmFormularfeldId, { createGtmFieldId } from '../../../gtm/types/GtmFormularfeldId';


/**
 * ########################
 * MaskedInput wichtig!
 * https://github.com/text-mask/text-mask
 * https://github.com/text-mask/text-mask/tree/master/react#readme
 * -----------------------
 * Die Komponente MUSS ausserhalb der render Klasse / Funktion liegen.
 * Innherhalb der Klasse /Funktion verliert das Eingabefeld seinen Fokus!
 * ########################
 * integration 3rd-party-input-libraries
 * 
 * The following demo uses the react-text-mask and react-number-format libraries. 
 * The same concept could be applied to e.g. react-stripe-element.
 * Quelle:
 * https://material-ui.com/components/text-fields/#integration-with-3rd-party-input-libraries
 * 
 * 
 * react-text-mask
 * https://github.com/text-mask/text-mask/tree/master/react/#readme
 * https://www.npmjs.com/package/react-text-mask
 * 
 * 
 */
const maskPlaceholder = '41460';

const PlzMaskedInput = ({ ...props }) => {
    const { value, inputRef, ...other } = props;
    return (
        <NumberFormat
            {...other}
            format="#####"
            placeholder={maskPlaceholder}
            value={value}
        />
    );
};


type Param = {
    onBlur: (event: React.FocusEvent<HTMLInputElement>) => void,
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
    value?: string,
    label?: string,
    id: string,
    idGtm: GtmFormularfeldId,
    idGtmIndex?: number
    error?: boolean,
    helperText?: string,
    required?: boolean
}



const PlzField: React.FC<Param> = ({ onBlur, onChange, value, label, id, idGtm, idGtmIndex, error, helperText, required }) => {

    const handleOnFocus = () => {
        const gtmFieldId = createGtmFieldId(idGtm, idGtmIndex);
        GoogleTagManager.fireEventFormularfeld(gtmFieldId);
    }

    return (
        <TextField id={id} label={label}
            classes={muiTextFieldModuleCss}
            color='primary'
            value={value}
            onFocus={handleOnFocus}
            onBlur={onBlur}
            onChange={onChange}
            onKeyPress={InputEvents.preventOnKeyPressEnter}
            error={error}
            InputProps={{
                classes: muiInputModuleCss,
                inputProps: { inputMode: 'numeric' },
                inputComponent: PlzMaskedInput as any,
                endAdornment: <AdornmentState error={error} />
            }}
            InputLabelProps={{
                classes: muiInputLabelModuleCss,
                shrink: value ? true : undefined,
            }}
            placeholder={maskPlaceholder}
            helperText={helperText}
            required={required}
        />
    );
}

export default PlzField;